import React from 'react';
import { Card, CardBody, Col, Container, Row, UncontrolledTooltip } from 'reactstrap';
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';

const InformativeCardMultiData = ({
  label,
  additionalInfo,
  badge,
  badgeClass,
  prefix,
  suffix,
  separator,
  counter,
  decimal,
  decimals,
  duration,
  link_to,
  link_name,
  link_deactive,
  bgcolor,
  icon,
  secondLabel,
  tooltipLabel,
  secondTooltipLabel,
  secondCounter
}) => {
  return (
    <React.Fragment>
      <Card className="card-animate">
        <CardBody>
          <Container className="align-items-center p-0">
            <Row className='d-flex flex-grow-1'>
              <Col xs={6} className='flex-grow-1 overflow-hidden d-flex align-items-center'>
                <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                  {label}
                </p>
                {tooltipLabel && (
                  <>
                  <i
                    className="ri-question-line ms-1 text-muted"
                    style={{ cursor: 'pointer', fontSize: '14px' }}
                    id="required-field-info"
                  ></i>
                  <UncontrolledTooltip
                    placement="top"
                    target="required-field-info"
                  >
                    {tooltipLabel}
                  </UncontrolledTooltip>
                </>
                )}
              </Col>
              {secondLabel && (
                <Col xs={6} className='flex-grow-1 overflow-hidden'>
                  <Card className='mb-0 bg-warning-subtle border-1 border-warning rounded'>
                    <CardBody className="px-1 py-0">
                      <Row>
                        <Col className='d-flex align-items-center'>
                          <p className="fs-10 text-uppercase fw-medium text-warning text-truncate mb-0">
                            {secondLabel}
                          </p>
                          {secondTooltipLabel && (
                              <>
                                <i
                                  className="ri-question-line ms-1 text-warning"
                                  style={{ cursor: 'pointer', fontSize: '14px' }}
                                  id="required-field-info-2"
                                ></i>
                                <UncontrolledTooltip
                                  placement="top"
                                  target="required-field-info-2"
                                >
                                  {secondTooltipLabel}
                                </UncontrolledTooltip>
                              </>
                            )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <h4 className="fs-16 fw-bold ff-secondary mb-0 text-danger">
                            {tooltipLabel && (
                              <span className="counter-value" data-target={secondCounter}>
                                <CountUp
                                  start={0}
                                  prefix={prefix}
                                  suffix={suffix}
                                  decimal={decimal || ','}
                                  separator={separator}
                                  end={secondCounter}
                                  decimals={decimals}
                                  duration={duration}
                                />
                              </span>
                            )}
                          </h4>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              )}
            </Row>
            <div className="flex-shrink-0">
              {additionalInfo && (
                <h5 className={'fs-14 mb-0 text-' + badgeClass}>
                  {badge ? (
                    <i className={'fs-13 align-middle ' + badge}></i>
                  ) : null}{' '}
                  {additionalInfo}
                </h5>
              )}
            </div>
          </Container>
          <Container className={`align-items-end justify-content-between mt-${secondLabel ? 0 : 4} p-0`}>
            <Row className='d-flex flex-grow-1'>
              <Col>
                <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                  <span className="counter-value" data-target={counter}>
                    <CountUp
                      start={0}
                      prefix={prefix}
                      suffix={suffix}
                      decimal={decimal || ','}
                      separator={separator}
                      end={counter}
                      decimals={decimals}
                      duration={duration}
                    />
                  </span>
                </h4>
              </Col>
            </Row>

            <Row className='d-flex flex-grow-1'>
              <Col xs={9} className='align-self-end'>
                <Link
                  to={link_to}
                  className={`text-decoration-underline text-muted ${link_deactive ? 'pe-none' : 'pe-auto'}`}
                >
                  {link_name}
                </Link>
              </Col>
              <Col xs={3} className='d-flex justify-content-end'>
                {icon ? (
                  <div className="avatar-sm flex-shrink-0">
                    <span
                      className={
                        'avatar-title rounded fs-3 bg-' + bgcolor + '-subtle'
                      }
                    >
                      <i className={`text-${bgcolor} ${icon}`}></i>
                    </span>
                  </div>
                ) : null}
              </Col>
            </Row>
          </Container>
        </CardBody>
      </Card>
    </React.Fragment >
  );
};

export default InformativeCardMultiData;
